module.exports = __webpack_public_path__ + "static/media/Россовский Г. (ДУ).24baa16a.pdf";